export default {
  LOGIN: "Login",
  FORGET_PASSWORD: "Forget Password",
  OTP_VERIFICATION: "OTP Verification",
  LOGOUT: "Logout",
  REGISTER: "Register",
  RESET_PASSWORD: "Reset Password",
  BLS_FEEDBACK: "BLS Feedback",
  FEEDBACK_FORMS: "Feedback Forms",
  ADD_FEEDBACK_FORM: "Add Feedback Form",
  EDIT_FEEDBACK_FORM: "Edit Feedback Form",
  CUSTOMER_MANAGEMENT: "Customer Management",
  CUSTOMER_DETAILS: "Customer Details",
  NOTIFICATION_MANAGEMENT: "Notification Management",
  VIEW_NOTIFICATION: "View Notification",
  EDIT_NOTIFICATION: "Edit Notification",
  ADD_NOTIFICATION: "Add Notification",
  CONTENT_LIBRARY: "Content Library",
  VIEW_CONTENT_LIBRARY_ITEM: "View Content",
  ADD_CONTENT_LIBRARY_ITEM: "Add Content",
  EDIT_CONTENT_LIBRARY_ITEM: "Edit Content",
  EDIT_PROFILE: "Edit Profile",
  CHANGE_PASSWORD: "Change Password",
  CLICK_ANALYTICS: "Click Analytics",
  CLICK_ANALYTICS_DETAILS: "Click Analytics Details",
  USER_ANALYTICS: "User Analytics",
  ADMIN_ACCESS: "MCAP Access",
  SCHOOL_ADMIN_REQUESTS: "School Admin Requests",
  DISTRICT_HUB: "District Hub",
  ALIGN_USERS: "Align Users",
  LICENSE_PLANS: "Plans & Pricing",
  LICENSE_PAYMENTS: "Payments",
  DEMO_AVAILABILITY: "Demo Availability",
};
